import React from 'react'
import Icon from 'meinian-package/src/component/icon'
import { CreateOrEditChildIdeaMass } from 'meinian-package/src/component'
import './index.less'
import classNames from 'classnames'

export default ({ info, style, disabled, onChange }) => {
  return <CreateOrEditChildIdeaMass
    parentId={info.id}
    currentRole={info?.loginUserInfo?.role}
    onChange={onChange}
  >
    <div className={classNames('mn-child-create-inspiration', { disabled })} style={style}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Icon type="m-xinjianlingganji" className="mn-child-create-inspiration-icon" />
        <div className="mn-child-create-inspiration-info">新建子灵感集</div>
      </div>
      <Icon type="m-tianjia" className="mn-child-create-inspiration-add-icon" />
    </div>
  </CreateOrEditChildIdeaMass>
}
